import React from 'react';
import { styled } from '@mui/material/styles';
import Grid from '@mui/material/Grid';
import CircularProgress from '@mui/material/CircularProgress';

const PREFIX = 'LoadingSpinner';

const classes = {
  progress: `${PREFIX}-progress`,
};

const StyledGrid = styled(Grid)(({ theme }) => ({
  [`& .${classes.progress}`]: {
    margin: theme.spacing(2),
  },
}));

const LoadingSpinner = props => {
  return (
    <StyledGrid
      container
      spacing={0}
      direction='column'
      alignItems='center'
      justifyContent='center'
      style={{ minHeight: '100vh' }}
    >
      <CircularProgress className={classes.progress} />
    </StyledGrid>
  );
};

export default LoadingSpinner;
